const appTheme = {
    appColor: {
        primary: '#0B407D',
        darkBlue:'#0B407D',
        secondary: '#FF9800',
        success: '#029C48',
        warning: '#E18600',
        danger: '#D72F2F',
        gray: '#999999',
        lightGray :'#666666',
        darkGray: '#575757',
        grey: '#c5c5c5',
        black: '#282828',
        white: '#fff',
        info: '#03a9f4'
    },
    linkStyle: {
      color: '#0073ff'
    },
    default: {
      fontSize: 14,
      fontFamily: "'Poppins', sans-serif",
      btnBorderType: 'square',
      color:'#282828'
    },
  };

export default appTheme;
